import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Tooltip } from 'next-common-lib';
import i18n from 'i18n';
import DeleteButton from 'components/Common/Buttons/DeleteButton';
import * as wizardActions from 'redux/ducks/common/wizardDuck';
import * as jobTitleActions from 'redux/ducks/JobTitle/JobTitleDucks';

export const InputJobTitle = () => {
  const dispatch = useDispatch();
  const jopTitleList = useSelector(state => state.jobTitle.jobTitleListArray);

  return (
    <div>
      <Button
        componentType="normal"
        label={i18n.t('BTY_W_T_POSITION_ADD')}
        className="add"
        iconInfo={{ className: 'ic-plus ', size: 'sm' }}
        disabled={jopTitleList?.length === 20}
        tabIndex={0}
        onClick={() => {
          dispatch(wizardActions.openPopup({}));
        }}
      />
      {jopTitleList?.map(item => {
        return (
          <div className="view-box" key={item.compStrcCd}>
            <Tooltip componentType="move" label={[`${item.compStrcCdNm}`]}>
              <div className="view-box-content">
                <div className="view-option">
                  <div className="tit">
                    <div className="pt-badge round size-min bg-c200">
                      <span className="text">Code</span>
                    </div>
                    <p className="sub-main-text">{item.compStrcCd}</p>
                  </div>
                </div>
                <p className="main-text">{item.compStrcCdNm}</p>
              </div>
            </Tooltip>
            <DeleteButton
              handleOnclick={() =>
                dispatch(
                  jobTitleActions.deleteJobTitle({
                    data: { compStrcCdList: [item.compStrcCd] },
                    id: item.compStrcCd,
                  }),
                )
              }
            />
          </div>
        );
      })}
    </div>
  );
};

InputJobTitle.propTypes = {};
InputJobTitle.defaultProps = {};
export default InputJobTitle;
